import { fontSize } from '@mui/system';
import { displayInlineBlock, poppins400 } from 'theme/common.style';

export const statusLiveHead = {
  ...displayInlineBlock,
  fontFamily: 'Poppins !important',
  fontStyle: 'normal !important',
  fontWeight: '400 !important',
  paddingLeft: '15px',
  color: '#262626',
};

export const statusCont = {
  display: 'flex',
  alignItems: 'center',
  //border:"1px solid green"
  //paddingBottom: "10px",
};
export const currentweek = {
  display: 'flex',
  'align-items': 'center',
};
